import * as React from 'react';
import Text from 'components/Text';
import { NavigationItem, NavigationItemProps } from './NavigationItem';
import './styles/NavigationSection.scss';

export type NavigationSectionProps = {
  title?: string;
  items: ({ key: string } & NavigationItemProps)[];
};

export const NavigationSection = ({ title, items }: NavigationSectionProps) => {
  return (
    <section className="NavigationSection">
      {title && (
        <Text
          data-testid="NavigationSection-title"
          size="xxsmall"
          element="h3"
          color="black"
          className="NavigationSection-title"
          weight="semibold">
          {title}
        </Text>
      )}

      {items.map(item => (
        <ul key={item.key}>
          <NavigationItem {...item} />
        </ul>
      ))}
    </section>
  );
};
